module.exports = __webpack_public_path__ + "img/22.5e4bf69e.jpg";